import {
    ADD_PRODUCTS,
    ADD_POPULAR_PRODUCTS,
    ADD_FILTERS
  } from "./shopActionsTypes";
  
  const initialState = {
    products: [],
    popularProducts: [],
    filters: [],
    breadcrumb: []
  };
  
  // Вспомогательный нормалайзер, как в Product Store
  function normalizeProduct(product) {
    const price =
      typeof product.price === "object" && product.price.data !== undefined
        ? Number(product.price.data)
        : product.price;
    const images = Array.isArray(product.images) ? product.images : [];
    const attributes = product.attributes
      ? product.attributes
      : Object.fromEntries(
          (product.characteristic_list?.list || []).map(({ name, value }) => [
            name,
            value
          ])
        );
    return { ...product, price, images, attributes };
  }
  
  function addProducts(state, products) {
    return {
      ...state,
      products: products.map(normalizeProduct)
    };
  }
  
  function addPopularProducts(state, products) {
    return {
      ...state,
      popularProducts: products.slice(0, 15).map(normalizeProduct)
    };
  }
  
  function addFilters(state, category) {
    // собираем items из category.children
    const items = (category.children || []).map(sub => ({
      id: sub.id,
      name: sub.name,
      type: "child",
      url: sub.id
    }));
  
    // добавляем «Назад» если нужен
    if (category.parent) {
      items.push({
        id: category.parent,
        name: "Назад",
        type: "parent",
        url: category.parent
      });
    }
  
    return {
      ...state,
      filters: [
        {
          id: category.id,
          name: category.name,
          type: "categories",
          options: { items }
        }
      ]
      // breadcrumb можно обновить аналогично, если нужно
    };
  }
  
  export default function shopReducer(state = initialState, action) {
    switch (action.type) {
      case ADD_PRODUCTS:
        return addProducts(state, action.payload);
      case ADD_POPULAR_PRODUCTS:
        return addPopularProducts(state, action.payload);
      case ADD_FILTERS:
        return addFilters(state, action.payload);
      default:
        return state;
    }
  }
  